import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

const AuthModule = namespace("UserModule");

@Component
export default class Splash extends Vue {
  @AuthModule.Getter
  isLoggedIn!: boolean;

  mounted() {
    setTimeout(() => {
      if (this.isLoggedIn) this.$router.replace("/dashboard");
      else this.$router.replace("/login");
    }, 2000);
  }
}
